import React from "react";
import { QRCode } from '../qrcode'
import PointBase from "./Base/PointBase";
import { pointOptions } from "./ultil";


/**
 * @QrProvider(
 *   id = "cross",
 *   title = @Translation("Cross")
 * )
 */
export default class RendererCross extends PointBase {
	/**
	 * constructor
	 * @param $options
	 * @param $qrcode
	 * @param $name
	 */
	constructor($options: any = {}, $qrcode: QRCode, $name?: string) {
		
		const pointRender = ($options: any) => {
			let $opts = pointOptions($options, ['transform', 'fill'], [], function ($opts: any){
				let { x, y, scale } = $opts || {};
				return Object.assign($opts, { "transform": `translate(${x},${y}) scale(${scale})` });
			});
			
			return (<path {...$opts} d="M100.291 25.5557H75.2911V0.555603H25.2908V25.5557H0.29068V75.556H25.2908V100.556H75.2911V75.556H100.291V25.5557Z"/>);
		}
		
		Object.assign($options, {pos: pointRender})
		
		super($options, $qrcode, $name || 'RendererCross');
	}
}
